import React from "react";
import { Button } from "design-system/components/button/button";
import { ButtonSize } from "design-system/components/button/button.types";
import {
  TutorialTitle,
  StepItem,
  StepTextContainer,
  StepBadge,
  StepTitle,
  StepImage,
  MobileOnly,
  DesktopOnly,
  TutorialContainer
} from "./tutorial-content.styles";

interface TutorialContentProps {
  onClick: () => void;
}

export const TutorialContent: React.FC<TutorialContentProps> = ({
  onClick
}) => {
  return (
    <TutorialContainer>
      <TutorialTitle>Ikuti 3 langkah mudah berikut:</TutorialTitle>

      <StepItem>
        <StepTextContainer>
          <StepBadge>1 dari 3</StepBadge>
          <StepTitle>Kerjakan soal di buku atau kertasmu</StepTitle>
        </StepTextContainer>
        <StepImage
          src="/assets-v2/illustrations/how_to_1.svg"
          alt="Kerjakan soal"
        />
      </StepItem>

      <StepItem>
        <StepTextContainer>
          <StepBadge>2 dari 3</StepBadge>
          <StepTitle>Foto jawaban dan coretan pengerjaanmu</StepTitle>
        </StepTextContainer>
        <MobileOnly>
          <StepImage
            src="/assets-v2/illustrations/how_to_2_mobile.svg"
            alt="Foto jawaban"
          />
        </MobileOnly>
        <DesktopOnly>
          <StepImage
            src="/assets-v2/illustrations/how_to_2_desktop.svg"
            alt="Foto jawaban"
          />
        </DesktopOnly>
      </StepItem>

      <StepItem>
        <StepTextContainer>
          <StepBadge>3 dari 3</StepBadge>
          <StepTitle>Jawabanmu akan dicek oleh Kak Caca</StepTitle>
        </StepTextContainer>
        <StepImage
          src="/assets-v2/illustrations/how_to_3.svg"
          alt="Kak Caca cek jawaban"
        />
      </StepItem>

      <Button
        appearance="general"
        variant="primary"
        size={ButtonSize.lg}
        isFullWidth
        onClick={onClick}
      >
        Oke, udah paham
      </Button>
    </TutorialContainer>
  );
};
